import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, ComponentFactory, ComponentRef, EmbeddedViewRef, ApplicationRef, Injector, HostListener } from '@angular/core';
//import { TranslateService, LangChangeEvent } from 'ng2-translate';
import { ApplicationConstants } from './../providers/application-constants';
import { Utils } from './../providers/utils';
import { QueryList } from './../providers/query-list';
import { Router } from '@angular/router';
// import { Classes } from '../providers/classes';
import { NgxSpinnerService } from 'ngx-spinner';

import {TranslateService} from '@ngx-translate/core';
// import { TranslateService, LangChangeEvent } from 'ng2-translate';

// import { ItemCatComponent } from './item-cat/item-cat.component';
// import { ItemCatListComponent } from './item-cat-list/item-cat-list.component';

@Component({
  selector: 'app-root',
  template: `  
     <p>Screen width: {{ screenWidth }}</p>  
     <p>Screen height: {{ screenHeight }}</p>  
  `,  
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  @ViewChild("ctrl_mainView", { read: ViewContainerRef }) container;
// test from 
  // title = 'مستشار الحسابات';
  public view;
  public isLogged: boolean = false;
  private componentRef:ComponentRef<any>;
  //private ItemCatComponent:ItemCatComponent; public translate: TranslateService,
  //links: Array<{ text: string, path: string }> = [];  private classes:Classes, 
  textDir: string = "ltr";

  public screenWidth: any;  
  public screenHeight: any;  

  constructor( public applicationConstants:ApplicationConstants, public spinner: NgxSpinnerService, 
    private utils: Utils, private queryList: QueryList, private router: Router, 
    private componentFactoryResolver: ComponentFactoryResolver, public translate: TranslateService) { 
    
    if (this.applicationConstants.user_lang == 'ar')
      this.textDir = 'rtl';
    else 
      this.textDir = 'ltr';

    this.translate.setDefaultLang(this.applicationConstants.user_lang);
    this.translate.use(this.applicationConstants.user_lang);

    console.log('app comp');
    this.applicationConstants.appComp = this;
    // translate.setDefaultLang('ar');
    // translate.use('ar');
    // let query3 = "SELECT * FROM `param` WHERE `status` != '0'";
    // let obj3 = { cmd: 'getList', query: query3 };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj3)
    //   .subscribe(data => {
    //     this.hideBusyCursor();
    //     this.applicationConstants.param = data.data['list'];
    //     console.log(this.applicationConstants.param);
    //   });

    // this.isLogged = this.applicationConstants.isLogged;
    // this.generateRouting();
    
    /*let query = this.queryList.all_main_menu;
    let obj = {cmd: 'getList', query:query};

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.hideBusyCursor();
        this.applicationConstants.main_menu = [];
        let main_menu = data.data['list'];
        let index = 0;
        let col_num = 3;
        let row_obj;

        let menu_len = main_menu.length;
        if(menu_len == 4)
          col_num = 2;
        else if(menu_len > 6 && menu_len <= 8) // make number of item in row = 4
          col_num = 4;
        else if(menu_len > 8  && menu_len <= 10)
          col_num = 5;
        else if(menu_len > 10)
          col_num = 6;
        
        main_menu.forEach(element => {
          if(index % col_num == 0) {
            row_obj = {'row_index':this.applicationConstants.main_menu.length, 'col_list':[]};
            this.applicationConstants.main_menu.push(row_obj);
          } 
          row_obj.col_list.push(element);
          index++;
        });
        
      });

    let query2 = this.queryList.all_sub_menu;
    let obj2 = {cmd: 'getList', query:query2};

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.hideBusyCursor();
        this.applicationConstants.sub_menu_all = data.data['list'];
        
    });*/

  }

  ngOnInit() {

    this.screenWidth = window.innerWidth;  
    this.screenHeight = window.innerHeight;  

    /** spinner starts on init */
    // this.spinner.show();
 
    // setTimeout(() => {
    //     /** spinner ends after 5 seconds */
    //     this.spinner.hide();
    // }, 5000);
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) {  
    this.screenWidth = window.innerWidth;  
    this.screenHeight = window.innerHeight;  
  }  

  ngDoCheck()	{
    // this.isLogged = this.applicationConstants.isLogged;
  }

  // generateRouting() {
     // add routing list dynamiclly
     //instance creation here
     //this.view = Object.create(window["./item-cat/item-cat.component"].prototype);
     //console.log(this.view);
     //console.log(window);
     //this.view.constructor.apply(this.view); // , new Array("World") parameter
     /*this.router.config.unshift({ path: 'sub_menu/5/item_cat', 
     component: ItemCatComponent}); // this.view ItemCatListComponent
     this.router.config.unshift({ path: 'sub_menu/5/item_cat_list', 
     component: ItemCatListComponent});
     console.log('app const');

    const dynModule = require('./item-cat/item-cat.component');
    const klass = dynModule["ItemCatComponent"];


    let instance: any = new klass();*/

  // }

  // public addView() {
  //   if(this.componentRef != undefined)
  //     this.componentRef.destroy(); 
  //   this.container.clear();
  //   this.view = null;
  //   this.view = this.classes.getClassByName('ItemCatComponent');
  //   console.log(this.view);
    
  //   this.applicationConstants.views.push(this.view);
  //   const factory = this.componentFactoryResolver.resolveComponentFactory(this.view);
  //   this.componentRef = this.container.createComponent(factory);
  // }

  // public newComp() {
  //   //this.componentRef.destroy(); 
  //   this.container.clear();
  //   this.view = null;
  //   this.view = this.classes.getClassByName('QutationListComponent');
    
  //   console.log(this.view);
    
  //   this.applicationConstants.views.push(this.view);
  //   const factory = this.componentFactoryResolver.resolveComponentFactory(this.view);
  //   this.componentRef = this.container.createComponent(factory);
  // }

  // public back() {
  //   this.applicationConstants.views.pop();
  //   //this.componentRef.destroy(); 
  //   //this.view = null;
  //   let i = this.applicationConstants.views.length-1;
  //   this.container.clear();
  //   this.view = this.applicationConstants.views[i];//this.classes.getClassByName('ItemCatComponent');
  //   console.log(this.view);
    
  //   //this.applicationConstants.views.push(this.view);
  //   const factory = this.componentFactoryResolver.resolveComponentFactory(this.view);
  //   this.componentRef = this.container.createComponent(factory);

  // }

  // public home() {
  //   this.componentRef.destroy(); 
  //   this.container.clear();
  //   this.applicationConstants.views = [];
  // }

  public showBusyCursor() {
    this.spinner.show();
  }

  public hideBusyCursor() {
      this.spinner.hide();
  }

}
